var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-tree-wrap" },
    [
      _c("el-tree", {
        ref: "menuTree",
        staticClass: "tree",
        attrs: {
          data: _vm.menus,
          props: _vm.defaultProps,
          "node-key": "id",
          "default-expand-all": true,
          "default-expanded-keys": _vm.matchMenus,
          "check-strictly": true,
          accordion: ""
        },
        on: { "node-click": _vm.handleNodeClick },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function(ref) {
                var node = ref.node
                var data = ref.data
                return !data.show
                  ? _c(
                      "div",
                      {
                        staticClass: "custom-tree-node",
                        class: data.slotClass
                      },
                      [
                        data.component
                          ? [
                              _c(data.component.template, {
                                tag: "component",
                                style: data.component.class,
                                attrs: { lineHeight: 40 }
                              })
                            ]
                          : _vm._e(),
                        data.nodeIcon
                          ? _c("span", { class: data.nodeIcon })
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass: "node-name",
                            attrs: { title: node.label }
                          },
                          [_vm._v(_vm._s(node.label))]
                        ),
                        _c(
                          "div",
                          { staticClass: "slot-wrap" },
                          [
                            data.slots
                              ? _vm._l(data.slots, function(item, index) {
                                  return _c(
                                    "slot-temp",
                                    {
                                      key: "slot-" + index,
                                      staticStyle: { "margin-left": "5px" },
                                      on: { clickSlot: item.clickFunc }
                                    },
                                    [
                                      _c("i", {
                                        class: item.iconClass,
                                        attrs: { title: item.hoverTitle }
                                      })
                                    ]
                                  )
                                })
                              : _vm._e()
                          ],
                          2
                        ),
                        data.badge !== ""
                          ? [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.currentPath === data.id ||
                                        (_vm.currentPath ===
                                          "/corp/signInfo/sealApproval?signStatus=6" &&
                                          data.id ===
                                            "/corp/signInfo/signList?signStatus=5"),
                                      expression:
                                        "currentPath === data.id || (currentPath === '/corp/signInfo/sealApproval?signStatus=6' && data.id === '/corp/signInfo/signList?signStatus=5')"
                                    }
                                  ],
                                  staticClass: "badge"
                                },
                                [_vm._v(_vm._s(data.badge))]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b2429c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b2429c5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/apply-menu-tree/index.vue
// module id = 77GF
// module chunks = 0 23 24 90 94